<template>
  <div class="home-classic">
    <div class="navbar-top-center">
      <NavigationBar />
    </div>
    <div class="miletus-image-full">
      <img src="/ruins.jpg" alt="Ruins of Miletus" class="miletus-main-full" />
      <div class="miletus-caption-corner">Miletus (2015)</div>
    </div>
  </div>
</template>

<script>
import NavigationBar from './NavigationBar.vue';
export default {
  name: 'HomePage',
  components: { NavigationBar }
};
</script>

<style scoped>
.home-classic {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-family: serif;
  background: none;
}

.miletus-image-full {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  z-index: 1;
}

.miletus-main-full {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.miletus-caption-corner {
  position: absolute;
  left: 2vw;
  bottom: 2vh;
  z-index: 2;
  font-size: 2rem;
  color: #fff;
  background: none;
  padding: 0.3rem 1.2rem;
  border-radius: 0;
  font-weight: bold;
  text-align: left;
  box-shadow: none;
}

.navbar-top-center {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  width: auto;
  padding-top: 2vh;
  background: none;
}

.navbar-top-center .navbar-classic {
  justify-content: center;
}
</style>